import { GPC_METHODOLOGY_LOOKUP_MAP } from "./methodology-lookup";
const stationary = GPC_METHODOLOGY_LOOKUP_MAP.sectors.STATIONARY_ENERGY.energySources;
const transport = GPC_METHODOLOGY_LOOKUP_MAP.sectors.TRANSPORTATION.energySources;
export const GPC_SCOPE3_PARENT_BY_SOURCE_ID = {
    [stationary.ELECTRICITY_GRID_LOSSES.id]: stationary.ELECTRICITY.id,
    [stationary.HEATING_ELECTRICITY_GRID_LOSSES.id]: stationary.HEATING_ELECTRICITY.id,
    [stationary.DISTRICT_HEATING_GRID_LOSSES.id]: stationary.DISTRICT_HEATING.id,
    [stationary.LOCAL_HEATING_GRID_LOSSES.id]: stationary.LOCAL_HEATING.id,
    [transport.GASOLINE_CROSS_BORDER.id]: transport.GASOLINE.id,
    [transport.BIO_GASOLINE_CROSS_BORDER.id]: transport.BIO_GASOLINE.id,
    [transport.DIESEL_CROSS_BORDER.id]: transport.DIESEL.id,
    [transport.DIESEL_BIOGENIC_CROSS_BORDER.id]: transport.DIESEL_BIOGENIC.id,
    [transport.KEROSENE_CROSS_BORDER.id]: transport.KEROSENE.id,
    [transport.LPG_CROSS_BORDER.id]: transport.LPG.id,
    [transport.NATURAL_GAS_CNG_LNG_CROSS_BORDER.id]: transport.NATURAL_GAS_CNG_LNG.id,
    [transport.BIO_CNG_CROSS_BORDER.id]: transport.BIO_CNG.id,
    [transport.ELECTRICITY_CROSS_BORDER.id]: transport.ELECTRICITY.id,
};
